import { ChangeDetectionStrategy, Component, Input, OnInit , signal } from '@angular/core';
import { first, fromEvent, merge } from 'rxjs';
import { AccountService } from 'src/app/services/account/account.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { ProfileComponent } from '../../profile/profile.component';
import { ProfileDropdownComponent } from '../../profile-dropdown/profile-dropdown.component';

@Component({
  standalone: true,
  selector: 'app-profile-panel',
  templateUrl: './profile-panel.component.html',
  styleUrls: ['./profile-panel.component.scss'],
  imports: [ProfileComponent, ProfileDropdownComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfilePanelComponent implements OnInit {
  @Input() loadingMap?: string | null;
  public readonly dropdownVisible = signal<boolean>(false);

  constructor(
    private utilsService: UtilsService,
    private accountService: AccountService
  ) {}

  ngOnInit(): void {}

  public onProfileToggleRequested(): void {
    if (this.dropdownVisible()) {
      this.dropdownVisible.set(false);
      return;
    }

    this.dropdownVisible.set(true);

    const clickEvent = fromEvent(document, 'click', { capture: true });
    const touchstartEvent = fromEvent(document, 'touchstart', { capture: true });

    merge(clickEvent, touchstartEvent).pipe(first()).subscribe((event: Event) => {
      if (!this.utilsService.isClassInParentChain(event, 'profile-panel')) {
        this.dropdownVisible.set(false);
      }
    });
  }
}
